import { createAction, props } from "@ngrx/store";
import { ImageProfileItemState } from "./models";

export default {
  imageProfileLoading: createAction("[Image Profile] loading"),
  imageProfileLoaded: createAction("[Image Profile] Image Profile loaded successfully", props<{ items: ImageProfileItemState[] }>()),
  reset: createAction("[Image Profile] reseted"),
  error: createAction("[Image Profile] error", props<{ error: string }>())
};
